import { put, takeEvery } from "@redux-saga/core/effects";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import AxiosCustom from "../../../common/components/apiConfig";

export const actionTypes = {
	selectCreditRequests: "[selectCreditRequests] Action",
	selectCreditRequestsLoad: "[selectCreditRequestsLoad] Action",
	selectCreditRequestsAsync: "[selectCreditRequestsAsync] Action",
};

const initialState = {
	data: [],
	loading: false,
};

export const select_credit_requests_reducer = (
	state = initialState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.selectCreditRequests:
			return {
				...state,
				data: payload?.data?.results ? payload?.data?.results : [],
			};

		case actionTypes.selectCreditRequestsLoad:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.selectCreditRequestsLoad, payload: payload });
	let config = {
		url: "select_request",
	};

	let data = {
		table: "credit",
		method_type: "select_credit_requests",
		data: payload?.data ? payload?.data : {},
		sort_by: {},
		size: "50",
		from: "0",
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		yield put({
			type: actionTypes.selectCreditRequests,
			payload: res.data.response,
		});
	} catch {
		handleNotificationAlertCatch();
		// yield put({ type: actionTypes.creaditSelectLoad, payload: false });
	} finally {
		yield put({ type: actionTypes.selectCreditRequestsLoad, payload: false });
	}
}

export function* selectCreditRequests() {
	yield takeEvery(actionTypes.selectCreditRequestsAsync, handleWorker);
}
